import React, { useState } from 'react';
import './MascotTest.css';

const MascotTest = () => {
  const [isFlexing, setIsFlexing] = useState(false);
  const [mood, setMood] = useState('happy'); // 'happy', 'pumped'
  const [mascotType, setMascotType] = useState('dog'); // 'blob', 'dog', 'robot'
  
  const [accessories, setAccessories] = useState({
    glasses: false,
    dumbbell: false,
    headphones: false,
    chain: false
  });

  const toggleAccessory = (acc) => {
    setAccessories(prev => ({ ...prev, [acc]: !prev[acc] }));
  };

  const handleInteract = () => {
    setIsFlexing(true);
    setMood('pumped');
    setTimeout(() => {
      setIsFlexing(false);
      setMood('happy');
    }, 1500);
  };

  // Dynamic layout offsets and colors based on mascot type
  const getLayout = () => {
    switch (mascotType) {
      case 'dog': 
        return { 
          eyeY: 85, 
          eyeR: 7,
          eyeColor: '#2f3640', 
          pupilR: 2,
          pupilColor: '#fff', 
          glassesY: -10, 
          chainY: 20, 
          dbX: 55, // Left paw X
          dbY: 160 // Left paw Y
        };
      case 'robot': 
        return { 
          eyeY: 85, 
          eyeR: 8,
          eyeColor: '#00f2fe', 
          pupilR: 0,
          pupilColor: 'transparent', 
          glassesY: -15, 
          chainY: 0, 
          dbX: 20, 
          dbY: 140 
        };
      default: // blob
        return { 
          eyeY: 100, 
          eyeR: 8,
          eyeColor: '#fff', 
          pupilR: 4,
          pupilColor: '#1a1a2e', 
          glassesY: 0, 
          chainY: 0, 
          dbX: 30, 
          dbY: 140 
        };
    }
  };
  const l = getLayout();

  return (
    <div className="mascot-container premium-bg">
      <h1 style={{ color: '#fff', marginBottom: '1rem', fontWeight: 700, letterSpacing: '-0.5px' }}>Test de la Mascotte SVG</h1>
      <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '2rem' }}>Défi relevé : Voici un Shiba Inu 100% vectoriel.</p>
      
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button className={`aesthetic-btn secondary ${mascotType === 'blob' ? 'active' : ''}`} onClick={() => setMascotType('blob')}>💧 Le Blob</button>
        <button className={`aesthetic-btn secondary ${mascotType === 'dog' ? 'active' : ''}`} onClick={() => setMascotType('dog')}>🐶 Shiba Musclé</button>
        <button className={`aesthetic-btn secondary ${mascotType === 'robot' ? 'active' : ''}`} onClick={() => setMascotType('robot')}>🤖 Fit-Bot</button>
      </div>
      
      <div 
        className={`mascot-svg-wrapper ${mascotType} ${isFlexing ? 'flexing' : 'idle'} ${mood}`} 
        onClick={handleInteract}
        style={{ cursor: 'pointer', width: '280px', height: '280px', position: 'relative' }}
      >
        <div className={`ambient-glow ${mood}`}></div>

        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style={{ zIndex: 2, position: 'relative' }}>
          <defs>
            <linearGradient id="happyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#4facfe" />
              <stop offset="100%" stopColor="#00f2fe" />
            </linearGradient>
            <linearGradient id="pumpedGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ff0844" />
              <stop offset="100%" stopColor="#ffb199" />
            </linearGradient>
            <linearGradient id="dogHappyGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#e67e22" />
              <stop offset="100%" stopColor="#d35400" />
            </linearGradient>
            <linearGradient id="dogPumpedGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#c0392b" />
              <stop offset="100%" stopColor="#e74c3c" />
            </linearGradient>
            <filter id="neonGlow" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="8" result="blur" />
              <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
            </filter>
            <linearGradient id="glassGrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="rgba(255,255,255,0.4)" />
              <stop offset="100%" stopColor="rgba(255,255,255,0.1)" />
            </linearGradient>
          </defs>

          {/* Shadow */}
          <ellipse cx="100" cy="185" rx="50" ry="12" fill="rgba(0,0,0,0.3)" className="mascot-shadow" />
          
          <g className="mascot-body-group" filter={mood === 'pumped' ? 'url(#neonGlow)' : 'none'}>
            
            {/* --- MASCOT: BLOB --- */}
            {mascotType === 'blob' && (
              <>
                <path d="M 50 100 C 50 40, 150 40, 150 100 C 150 160, 130 170, 100 170 C 70 170, 50 160, 50 100 Z" fill={mood === 'pumped' ? 'url(#pumpedGrad)' : 'url(#happyGrad)'} className="mascot-body" style={{ transition: 'all 0.4s ease' }} />
                <path d="M 60 90 C 60 50, 140 50, 140 90 C 140 100, 120 100, 100 100 C 80 100, 60 100, 60 90 Z" fill="url(#glassGrad)" style={{ opacity: 0.6 }} />
                <path d="M 50 110 Q 20 120, 30 140" stroke={mood === 'pumped' ? 'url(#pumpedGrad)' : 'url(#happyGrad)'} strokeWidth="12" strokeLinecap="round" fill="none" className="mascot-arm-left" style={{ transition: 'all 0.4s ease' }} />
                <path d="M 150 110 Q 180 120, 170 140" stroke={mood === 'pumped' ? 'url(#pumpedGrad)' : 'url(#happyGrad)'} strokeWidth="12" strokeLinecap="round" fill="none" className="mascot-arm-right" style={{ transition: 'all 0.4s ease' }} />
              </>
            )}

            {/* --- MASCOT: DOG (SHIBA) --- */}
            {mascotType === 'dog' && (
              <g className="mascot-dog">
                {/* Tail (curly) */}
                <path d="M 125 140 C 155 140, 165 110, 145 100 C 130 90, 115 110, 135 120" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="16" strokeLinecap="round" fill="none" style={{ transition: 'all 0.4s ease' }} />
                
                {/* Back Legs */}
                <path d="M 65 140 L 60 175" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="16" strokeLinecap="round" style={{ transition: 'all 0.4s ease' }} />
                <ellipse cx="55" cy="175" rx="12" ry="8" fill="#fff" />
                <path d="M 135 140 L 140 175" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="16" strokeLinecap="round" style={{ transition: 'all 0.4s ease' }} />
                <ellipse cx="145" cy="175" rx="12" ry="8" fill="#fff" />

                {/* Body */}
                <ellipse cx="100" cy="130" rx="45" ry="40" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} style={{ transition: 'all 0.4s ease' }} />
                {/* White Belly */}
                <ellipse cx="100" cy="135" rx="35" ry="30" fill="#fff" />

                {/* Front Arms (Left & Right) */}
                <g className="mascot-arm-left" style={{ transformOrigin: '70px 120px' }}>
                  <path d="M 70 120 L 55 160" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="14" strokeLinecap="round" style={{ transition: 'all 0.4s ease' }} />
                  <ellipse cx="52" cy="162" rx="10" ry="7" fill="#fff" />
                </g>
                <g className="mascot-arm-right" style={{ transformOrigin: '130px 120px' }}>
                  <path d="M 130 120 L 145 160" stroke={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} strokeWidth="14" strokeLinecap="round" style={{ transition: 'all 0.4s ease' }} />
                  <ellipse cx="148" cy="162" rx="10" ry="7" fill="#fff" />
                </g>

                {/* Head */}
                <g className="mascot-head">
                  {/* Left Ear */}
                  <path d="M 65 75 L 45 25 L 85 55 Z" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} style={{ transition: 'all 0.4s ease' }} />
                  <path d="M 62 70 L 52 35 L 78 55 Z" fill="#ff9ff3" />
                  {/* Right Ear */}
                  <path d="M 135 75 L 155 25 L 115 55 Z" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} style={{ transition: 'all 0.4s ease' }} />
                  <path d="M 138 70 L 148 35 L 122 55 Z" fill="#ff9ff3" />

                  {/* Head Base */}
                  <ellipse cx="100" cy="85" rx="55" ry="45" fill={mood === 'pumped' ? 'url(#dogPumpedGrad)' : 'url(#dogHappyGrad)'} style={{ transition: 'all 0.4s ease' }} />

                  {/* White Cheeks */}
                  <path d="M 45 85 C 45 125, 100 130, 100 105 C 100 130, 155 125, 155 85 C 155 115, 120 130, 100 130 C 80 130, 45 115, 45 85 Z" fill="#fff" />
                  
                  {/* Shiba Eyebrows (white dots) */}
                  <ellipse cx="75" cy="60" rx="6" ry="8" fill="#fff" transform="rotate(-20 75 60)" />
                  <ellipse cx="125" cy="60" rx="6" ry="8" fill="#fff" transform="rotate(20 125 60)" />

                  {/* Muzzle */}
                  <ellipse cx="100" cy="105" rx="20" ry="15" fill="#fff" />
                  {/* Nose */}
                  <ellipse cx="100" cy="100" rx="8" ry="5" fill="#2f3640" />
                </g>
              </g>
            )}

            {/* --- MASCOT: ROBOT --- */}
            {mascotType === 'robot' && (
              <>
                <line x1="100" y1="40" x2="100" y2="15" stroke="#7f8c8d" strokeWidth="4" />
                <circle cx="100" cy="10" r="6" fill={mood === 'pumped' ? '#ff0844' : '#00f2fe'} style={{ filter: 'url(#neonGlow)' }} />
                
                <rect x="45" y="40" width="110" height="110" rx="15" fill="#2c3e50" className="mascot-body" />
                <rect x="55" y="55" width="90" height="60" rx="8" fill="#1a1a2e" />
                <rect x="55" y="55" width="90" height="60" rx="8" fill="url(#glassGrad)" style={{ opacity: 0.2 }} />
                
                <g className="mascot-arm-left" style={{ transformOrigin: '35px 110px' }}>
                  <path d="M 35 110 L 15 130 L 25 140" stroke="#7f8c8d" strokeWidth="10" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
                </g>
                <g className="mascot-arm-right" style={{ transformOrigin: '165px 110px' }}>
                  <path d="M 165 110 L 185 130 L 175 140" stroke="#7f8c8d" strokeWidth="10" strokeLinecap="square" strokeLinejoin="miter" fill="none" />
                </g>
              </>
            )}

            {/* --- ACCESSORIES LAYER --- */}
            
            {/* Sweatband */}
            {mascotType !== 'robot' && accessories.glasses === false && (
              <>
                <path d={`M 52 ${75 + l.glassesY} Q 100 ${90 + l.glassesY}, 148 ${75 + l.glassesY} L 145 ${60 + l.glassesY} Q 100 ${75 + l.glassesY}, 55 ${60 + l.glassesY} Z`} fill="#111" />
                <path d={`M 60 ${70 + l.glassesY} Q 100 ${82 + l.glassesY}, 140 ${70 + l.glassesY}`} stroke="#00f2fe" strokeWidth="2" fill="none" style={{ filter: 'url(#neonGlow)', opacity: mood === 'pumped' ? 1 : 0.3 }} />
              </>
            )}

            {/* Chain */}
            {accessories.chain && (
              <g className="mascot-chain" style={{ transform: `translateY(${l.chainY}px)` }}>
                <path d="M 60 130 Q 100 160, 140 130" stroke="#f1c40f" strokeWidth="6" strokeLinecap="round" strokeDasharray="8 4" fill="none" />
                <circle cx="100" cy="148" r="10" fill="#f39c12" />
                <text x="95" y="153" fill="#fff" fontSize="14" fontWeight="bold">G</text>
              </g>
            )}

            {/* Eyes */}
            <g className="mascot-eyes">
              {mood === 'happy' && (
                <>
                  <circle cx="80" cy={l.eyeY} r={l.eyeR} fill={l.eyeColor} style={mascotType === 'robot' ? {filter:'url(#neonGlow)'} : {}} />
                  <circle cx="120" cy={l.eyeY} r={l.eyeR} fill={l.eyeColor} style={mascotType === 'robot' ? {filter:'url(#neonGlow)'} : {}} />
                  <circle cx="82" cy={l.eyeY} r={l.pupilR} fill={l.pupilColor} />
                  <circle cx="122" cy={l.eyeY} r={l.pupilR} fill={l.pupilColor} />
                </>
              )}
              {mood === 'pumped' && (
                <>
                  <path d={`M 70 ${l.eyeY - 5} L 90 ${l.eyeY + 5} L 70 ${l.eyeY + 5} Z`} fill={mascotType === 'robot' ? '#ff0844' : l.eyeColor} style={mascotType === 'robot' ? {filter:'url(#neonGlow)'} : {}} />
                  <path d={`M 130 ${l.eyeY - 5} L 110 ${l.eyeY + 5} L 130 ${l.eyeY + 5} Z`} fill={mascotType === 'robot' ? '#ff0844' : l.eyeColor} style={mascotType === 'robot' ? {filter:'url(#neonGlow)'} : {}} />
                </>
              )}
            </g>

            {/* Mouth */}
            {mascotType !== 'dog' && mascotType !== 'robot' && (
              <path d={mood === 'pumped' ? "M 90 120 Q 100 130, 110 120" : "M 90 115 Q 100 125, 110 115"} stroke="#fff" strokeWidth="4" strokeLinecap="round" fill="none" />
            )}
            {mascotType === 'dog' && (
              <path d={mood === 'pumped' ? "M 90 110 Q 100 125, 110 110 Z" : "M 90 110 Q 95 115, 100 110 Q 105 115, 110 110"} fill={mood === 'pumped' ? "#ff7675" : "none"} stroke="#2f3640" strokeWidth="2.5" strokeLinecap="round" />
            )}
            {mascotType === 'robot' && (
              <path d={mood === 'pumped' ? "M 80 100 L 90 105 L 100 100 L 110 105 L 120 100" : "M 80 105 L 120 105"} stroke={mood === 'pumped' ? '#ff0844' : '#00f2fe'} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" style={{ filter: 'url(#neonGlow)' }} />
            )}

            {/* Glasses */}
            {accessories.glasses && (
              <g className="mascot-glasses" style={{ transform: `translateY(${l.glassesY}px)`, transition: 'all 0.3s' }}>
                <path d="M 55 90 L 95 90 L 100 100 L 105 90 L 145 90 L 150 110 L 105 110 L 100 105 L 95 110 L 50 110 Z" fill="#111" />
                <path d="M 60 95 L 90 95 L 90 105 L 60 105 Z" fill="url(#pumpedGrad)" />
                <path d="M 110 95 L 140 95 L 140 105 L 110 105 Z" fill="url(#pumpedGrad)" />
              </g>
            )}

            {/* Headphones */}
            {accessories.headphones && (
              <g className="mascot-headphones" style={{ transform: `translateY(${l.glassesY}px)` }}>
                <path d="M 40 90 C 40 30, 160 30, 160 90" stroke="#fff" strokeWidth="8" fill="none" />
                <rect x="30" y="80" width="15" height="30" rx="5" fill="#333" />
                <rect x="155" y="80" width="15" height="30" rx="5" fill="#333" />
                <circle cx="37" cy="95" r="3" fill="#00f2fe" style={{ filter: 'url(#neonGlow)' }} />
                <circle cx="162" cy="95" r="3" fill="#00f2fe" style={{ filter: 'url(#neonGlow)' }} />
              </g>
            )}

            {/* Dumbbell */}
            {accessories.dumbbell && (
              <g className="mascot-dumbbell" style={{ transform: `translate(${l.dbX}px, ${l.dbY}px)`, transformOrigin: '0px 0px', animation: isFlexing ? 'flex-dumbbell 1s ease-in-out' : 'none' }}>
                <line x1="-15" y1="0" x2="15" y2="0" stroke="#7f8c8d" strokeWidth="6" />
                <rect x="-20" y="-15" width="10" height="30" rx="2" fill="#2c3e50" />
                <rect x="-25" y="-10" width="5" height="20" rx="1" fill="#34495e" />
                <rect x="10" y="-15" width="10" height="30" rx="2" fill="#2c3e50" />
                <rect x="20" y="-10" width="5" height="20" rx="1" fill="#34495e" />
              </g>
            )}
            
            {/* Sweat */}
            {mood === 'pumped' && mascotType !== 'robot' && (
              <g className="mascot-sweat">
                <path d="M 140 50 Q 145 60, 140 65 Q 135 60, 140 50" fill="#3498db" />
              </g>
            )}
          </g>
        </svg>
      </div>

      <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', zIndex: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button className="aesthetic-btn primary" onClick={handleInteract}>
          💪 Faire du sport
        </button>
        <button className={`aesthetic-btn secondary ${accessories.glasses ? 'active' : ''}`} onClick={() => toggleAccessory('glasses')}>
          🕶️ Lunettes
        </button>
        <button className={`aesthetic-btn secondary ${accessories.dumbbell ? 'active' : ''}`} onClick={() => toggleAccessory('dumbbell')}>
          🏋️ Haltère
        </button>
        <button className={`aesthetic-btn secondary ${accessories.headphones ? 'active' : ''}`} onClick={() => toggleAccessory('headphones')}>
          🎧 Casque
        </button>
        <button className={`aesthetic-btn secondary ${accessories.chain ? 'active' : ''}`} onClick={() => toggleAccessory('chain')}>
          ⛓️ Chaîne
        </button>
      </div>
    </div>
  );
};

export default MascotTest;
